<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{$t('questionsmodal.modal-card-title')}}</p>
    </header>
    <template v-if="confirmNoDocument || this.document">

      <section class="modal-card-body">

        <b-field :label="$t('questionsmodal.labeltheme1')" :type="errors.theme ? 'is-danger' : null" :message="errors.theme">
          <b-select v-model="theme" :placeholder="$t('questionsmodal.labeltheme2')">
            <option v-for="theme in questionThemes" :value="theme.id" :key="theme.id"> {{ theme.name }} </option>
          </b-select>
        </b-field>
        <b-field :label="$t('questionsmodal.labelobjet')" :type="errors.sujet ? 'is-danger' : null" :message="errors.sujet">
          <b-input v-model="sujet" />
        </b-field>
        <b-field :label="$t('questionsmodal.labelquestion')" :type="errors.question ? 'is-danger' : null" :message="errors.question">
          <b-input v-model="question" type="textarea" />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button :class="{ 'is-loading': loading }" class="button is-primary" @click="send">{{$t('questionsmodal.send')}}</button>
        <button class="button" type="button" @click="$parent.close()">{{$t('questionsmodal.cancel')}}</button>
      </footer>

    </template>
    <template v-else>
      <section class="modal-card-body no-document">

        <b-message type="is-warning" has-icon>
          <strong>{{$t('questionsmodal.message1')}}</strong><br>
          {{$t('questionsmodal.message2')}}
        </b-message>

        <p><strong>{{$t('questionsmodal.message3')}}</strong></p>

        <div class="columns">
          <div class="column">
            <ul>
              <li>{{$t('questionsmodal.message4')}}</li>
              <li>{{$t('questionsmodal.message5')}}</li>
              <li>{{$t('questionsmodal.message6')}}<br>{{$t('questionsmodal.message7')}}</li>
            </ul>
          </div>
          <div class="column is-one-third">
            <img src="../../assets/images/question-screenshot.png" />
          </div>
        </div>

        <p>{{$t('questionsmodal.message8')}}</p>

      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="confirmNoDocument = true">
          {{$t('questionsmodal.btn-oui')}}
        </button>
        <button class="button" type="button" @click="$parent.close()">
          {{$t('questionsmodal.btn-non')}}
        </button>
      </footer>

    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import MixinStringHelper from '@/mixins/StringHelper'

export default {
  mixins: [MixinStringHelper],
  props: {
    document: {
      type: Number,
      default: () => null,
    },
    an: {
      type: Number,
      default: () => null,
    },
    anLevel: {
      type: Number,
      default: () => null,
    },
  },
  data () {
    return {
      sujet: '',
      question: '',
      theme: null,
      loading: false,
      confirmNoDocument: false,
      errors: {},
    }
  },
  computed: {
    ...mapState({
      arboNot: state => state.inv.arboNot,
      questionThemes: state => state.inv.questionThemes,
    }),
    fullArboNot () {
      if (!this.an) return []

      let an = _.find(this.arboNot, { id: this.an })
      let arboNot = [an]
      while (an && an.parent && an.level > 0) {
        an = _.find(this.arboNot, { id: an.parent })
        arboNot.unshift(an)
      }
      return arboNot
    },
  },
  async created () {
    await this.$store.dispatch('inv/getQuestionThemes')
    this.getThemeFromArboNot()
  },
  methods: {
    getThemeFromArboNot () {
      if (this.fullArboNot.length === 0) return
      let an0Name = this.fullArboNot[0].name.replace(/^([^\s]+\s)/, '')

      // normalizeString defined in mixins/StringHelper.js
      // Assing to temporary variable as 'this' isn't available in anonymous functions.
      let tempNormalize = this.normalizeString
      const theme = _.find(this.questionThemes, function (t) {
        return tempNormalize(t.name.toLowerCase()) === tempNormalize(an0Name.toLowerCase())
      })
      if (theme) {
        this.theme = theme.id
      }
    },
    validate () {
      this.errors = {}
      // Clés fixes (sujet/question/theme), celles que lit le template — les clés
      // localisées ($t) valaient « subject » en anglais : le bouton Envoyer ne
      // faisait rien et aucun message ne s'affichait en locale EN.
      if (this.sujet.length === 0) {
        this.$set(this.errors, 'sujet', this.$t('questionsmodal.error1'))
      }
      if (this.question.length === 0) {
        this.$set(this.errors, 'question', this.$t('questionsmodal.error1'))
      }
      if (!this.theme) {
        this.$set(this.errors, 'theme', this.$t('questionsmodal.error1'))
      }
      return Object.keys(this.errors).length === 0
    },
    async send () {
      if (!this.validate()) return
      this.loading = true

      try {
        const formData = {
          sujet: this.sujet,
          question: this.question,
          theme: this.theme,
          bien: +this.$route.params.bien || null,
          portefeuille: +this.$route.params.portefeuille || null,
        }
        console.log(this.sujet + '-' + this.question + '-' + this.theme + '-' + this.$route.params.bien + '-' + this.$route.params.portefeuille + '-' + this.document)
        if (this.fullArboNot) {
          formData.an = this.fullArboNot.map(i => ({
            id: i.id,
            level: i.level,
          }))
        }
        if (this.document) {
          formData.document = this.document
        }
        await this.$api.post(`/inv/questions`, formData)
        this.$emit('sent')
        this.$parent.close()

        this.sujet = ''
        this.question = ''

        this.$toast.open(this.$t('questionsmodal.error5'))
      } catch (e) {
        this.apiError(e)
      }
      this.loading = false
    }
  },
}
</script>

<style lang="scss" scoped>
.no-document {
  p {
    margin-bottom: 1em;
  }

  p:last-child {
    margin-top: 1em;
    margin-bottom: 0;
    font-style: italic;
  }
}

ul {
  li {
    padding-top: .6em;
    list-style: square;
    margin-left: 2em;
  }
}

img {
  border: 8px solid #f6f6f6;
}
</style>
